'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002489 from "./presto.types$$anon$89.js";
import * as $j_presto$002etypes$0024$002dRule from "./presto.types$-Rule.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102 from "./presto.types$-Rule$$anon$102.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002490 from "./presto.types$-Rule$$anon$90.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002492 from "./presto.types$-Rule$$anon$92.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002494 from "./presto.types$-Rule$$anon$94.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
function $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either($thiz, c$1, kind) {
  var x = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind();
  if ((x === kind)) {
    return $thiz.cH5().F(c$1);
  }
  var x$3 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind();
  if ((x$3 === kind)) {
    return $thiz.cHc().F(c$1);
  }
  var x$5 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind();
  if ((x$5 === kind)) {
    return $thiz.cHh().F(c$1);
  }
  var x$7 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind();
  if ((x$7 === kind)) {
    return $thiz.cHj().F(c$1);
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(kind);
}
export { $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either as $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either };
/** @constructor */
function $c_Lpresto_types$Rule$() {
  this.c8I = null;
  this.c8L = false;
  this.c8E = null;
  this.c8F = false;
  this.c8G = null;
  this.c8H = false;
  this.c8M = null;
  this.c8N = false;
  this.c8O = null;
  this.c8P = false;
  this.c8J = null;
  this.c8K = false;
}
export { $c_Lpresto_types$Rule$ as $c_Lpresto_types$Rule$ };
$p = $c_Lpresto_types$Rule$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$;
/** @constructor */
function $h_Lpresto_types$Rule$() {
}
export { $h_Lpresto_types$Rule$ as $h_Lpresto_types$Rule$ };
$h_Lpresto_types$Rule$.prototype = $p;
$p.p5 = (function() {
  if ((!this.c8L)) {
    this.c8I = new $c_Lpresto_types$Rule$$anon$88(this);
    this.c8L = true;
  }
  return this.c8I;
});
$p.cH5 = (function() {
  if ((!this.c8F)) {
    this.c8E = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002490.$c_Lpresto_types$Rule$$anon$90(this);
    this.c8F = true;
  }
  return this.c8E;
});
$p.cHc = (function() {
  if ((!this.c8H)) {
    this.c8G = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002492.$c_Lpresto_types$Rule$$anon$92(this);
    this.c8H = true;
  }
  return this.c8G;
});
$p.cHh = (function() {
  if ((!this.c8N)) {
    this.c8M = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002494.$c_Lpresto_types$Rule$$anon$94(this);
    this.c8N = true;
  }
  return this.c8M;
});
$p.cHj = (function() {
  if ((!this.c8P)) {
    this.c8O = new $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102.$c_Lpresto_types$Rule$$anon$102(this);
    this.c8P = true;
  }
  return this.c8O;
});
$p.cHe = (function() {
  if ((!this.c8K)) {
    this.c8J = new $c_Lpresto_types$Rule$$anon$104(this);
    this.c8K = true;
  }
  return this.c8J;
});
$p.cFZ = (function(x$0) {
  return new $j_presto$002etypes$0024$002dRule.$c_Lpresto_types$Rule($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(1)), x$0.j(2), x$0.j(3), x$0.j(4), x$0.j(5), x$0.j(6));
});
var $d_Lpresto_types$Rule$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$, "presto.types$Rule$", ({
  a1v: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Rule$ as $d_Lpresto_types$Rule$ };
var $n_Lpresto_types$Rule$;
function $m_Lpresto_types$Rule$() {
  if ((!$n_Lpresto_types$Rule$)) {
    $n_Lpresto_types$Rule$ = new $c_Lpresto_types$Rule$();
  }
  return $n_Lpresto_types$Rule$;
}
export { $m_Lpresto_types$Rule$ as $m_Lpresto_types$Rule$ };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$104(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Rule$$anon$104 as $c_Lpresto_types$Rule$$anon$104 };
$p = $c_Lpresto_types$Rule$$anon$104.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$104;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$104() {
}
export { $h_Lpresto_types$Rule$$anon$104 as $h_Lpresto_types$Rule$$anon$104 };
$h_Lpresto_types$Rule$$anon$104.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.G = (function(c) {
  var this$1 = $m_Lpresto_types$Rule$();
  var this$2 = c.cGC("kind", $j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Sy());
  if ((this$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
    var b = this$2.bW;
    var this$3 = $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either(this$1, c, b);
    return ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right(this$3.bW) : this$3);
  } else {
    return this$2;
  }
});
var $d_Lpresto_types$Rule$$anon$104 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$104, "presto.types$Rule$$anon$104", ({
  a1x: 1,
  a: 1,
  f: 1
}));
export { $d_Lpresto_types$Rule$$anon$104 as $d_Lpresto_types$Rule$$anon$104 };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$88(outer) {
  this.c9c = null;
  this.c94 = null;
  this.c95 = false;
  this.c9d = null;
  this.c9e = false;
  this.c9h = null;
  this.c9a = null;
  this.c9b = false;
  this.c96 = null;
  this.c97 = false;
  this.c98 = null;
  this.c99 = false;
  this.c9f = false;
  this.c9g = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9c = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c9h = "Rule";
}
export { $c_Lpresto_types$Rule$$anon$88 as $c_Lpresto_types$Rule$$anon$88 };
$p = $c_Lpresto_types$Rule$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$88;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$88() {
}
export { $h_Lpresto_types$Rule$$anon$88 as $h_Lpresto_types$Rule$$anon$88 };
$h_Lpresto_types$Rule$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c9c;
});
$p.M = (function() {
  if ((!this.c95)) {
    this.c94 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c95 = true;
  }
  return this.c94;
});
$p.O = (function() {
  if ((!this.c9e)) {
    this.c9d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c9e = true;
  }
  return this.c9d;
});
$p.E = (function() {
  return this.c9h;
});
$p.t = (function() {
  if ((!this.c9b)) {
    this.c9a = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.c9b = true;
  }
  return this.c9a;
});
$p.N = (function() {
  if ((!this.c97)) {
    this.c96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($m_Lpresto_types$Rule$().cHe(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.c97 = true;
  }
  return this.c96;
});
$p.Q = (function() {
  if ((!this.c99)) {
    this.c98 = new $j_presto$002etypes$0024$0024anon$002489.$c_Lpresto_types$$anon$89();
    this.c99 = true;
  }
  return this.c98;
});
$p.v = (function() {
  if ((!this.c9g)) {
    this.c9f = false;
    this.c9g = true;
  }
  return this.c9f;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee82) => ((p) => \u03b4scrutinee82.cFZ(p)))($m_Lpresto_types$Rule$())));
});
var $d_Lpresto_types$Rule$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$88, "presto.types$Rule$$anon$88", ({
  a1y: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$88 as $d_Lpresto_types$Rule$$anon$88 };
//# sourceMappingURL=presto.types$-Rule$.js.map
